import styles from "./NullItem.module.scss";

const NullItem3 = () => {
  return <div className={styles.null} />;
}

export default NullItem3;